import { FormControl, Grid, IconButton, OutlinedInput, Typography } from "@mui/material";
import { ICredentialsOcasaProps } from "../../interfaces/configuration";
import { CUIT_PLACEHOLDER } from "../../utils/constants";
import { SimpleFormInput } from "./SimpleFormInput";
import { ChangeEvent, useState } from "react";
import { showInputErrors } from "../../utils/credentials";

const CredentialsOcasa = ({
  values,
  setValues,
  errors,
}: ICredentialsOcasaProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const baseInfo = {
    values,
    setValues,
  };

  return (
    <Grid container spacing={2}>
      <Grid item md={6}>
        <SimpleFormInput
          inputTitle="CUIT"
          placeholder={CUIT_PLACEHOLDER}
          valueName="user_cuit"
          errors={errors.user_cuit}
          {...baseInfo}
        />
      </Grid>
      <Grid item md={6}>
        <SimpleFormInput
          inputTitle="Id de cliente"
          placeholder="Ingresar el id de cliente"
          valueName="external_client_id"
          errors={errors.external_client_id}
          {...baseInfo}
        />
      </Grid>
      <Grid item md={6}>
        <FormControl size="small" fullWidth>
          <Typography className="f-s-14 m-b-10">Contraseña</Typography>
          <OutlinedInput
            autoComplete="off"
            type={showPassword ? "text" : "password"}
            placeholder="Ingrese la clave secreta de cliente"
            value={values.external_client_secret}
            error={errors.external_client_secret?.length > 0}
            onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) =>
              setValues({ ...values, external_client_secret: value.trim() })
            }
            className="f-s-14"
            endAdornment={
              <IconButton onClick={() => setShowPassword(!showPassword)}>
                <span className="material-symbols-rounded">
                  {showPassword ? "visibility_off" : "visibility"}
                </span>
              </IconButton>
            }
          />
          {errors.external_client_secret?.length > 0 && showInputErrors(errors.external_client_secret)}
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Typography className="f-s-20 m-t-10">Tipos de contratos</Typography>
      </Grid>
      <Grid item md={6}>
        <SimpleFormInput
          inputTitle="Código de contrato puerta a puerta"
          placeholder="Ingresar código de contrato puerta a puerta"
          valueName="door_to_door"
          errors={errors.door_to_door}
          {...baseInfo}
        />
      </Grid>
      <Grid item md={6}>
        <SimpleFormInput
          inputTitle="Código de contrato de logística inversa"
          placeholder="Ingresar código de logística inversa"
          errors={errors.reverse_logistics}
          valueName="reverse_logistics"
          {...baseInfo}
        />
      </Grid>
    </Grid>
  );
};

export default CredentialsOcasa;
